import { useState, useEffect } from "react"
import { useLoading } from "../../providers"
import config from "../../environments/generated.config"
import { Layout as Delete } from "./Layout/delete"
import { Layout as Checkout } from "./Layout/checkout"
import { redirect } from "../../utils/redirect.service"
import { sendMessage } from "../../utils/message.service"

export const Modal = ({ fn, props, deleteModal, variation, checkoutModal, isResume }) => {
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const { setLoading } = useLoading()

  const { home, checkout } = config.urls

  const handleDelete = async () => {
    setShow(false)
    setLoading(true)
    await fn(props)
    setLoading(false)
  }

  const scrollTop = () => {
    sendMessage({
      action: "scrollTop",
    })
  }

  useEffect(() => {
    show && scrollTop()
  }, [show])

  const handleCheckout = () => redirect(`${home}${checkout}/${props.type}`)

  const layoutProps = {
    show,
    handleClose,
    handleDelete,
    handleShow,
    isResume,
    handleCheckout,
    variation,
    type: props?.type,
  }

  return (
    <>
      {deleteModal && <Delete {...layoutProps} />}
      {checkoutModal && <Checkout {...layoutProps} />}
    </>
  )
}
